import { render } from "./WaiveFeesForm.vue?vue&type=template&id=6ca79b29"
import script from "./WaiveFeesForm.vue?vue&type=script&lang=js"
export * from "./WaiveFeesForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__